
const WhereWeAre = () => {
  return (
    <section id="donde-estamos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h4 className="text-sm font-semibold tracking-widest text-[#1a3a5c] uppercase mb-3">
            <a href="#donde-estamos">Presencia Global</a>
          </h4>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2d2d2d]">
            DONDE ESTAMOS
          </h2>
          <div className="w-20 h-1 bg-[#1a3a5c] mx-auto mt-4"></div>
        </div>
        <div className="w-full rounded-lg overflow-hidden shadow-lg">
          <img
            src="https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/d6a793aacb763046653dccb90a904044.png"
            alt="Mapa de presencia global de BIGBATTERY EUROPE - Red comercial internacional"
            title="BIGBATTERY EUROPE presencia global energía crítica"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default WhereWeAre;
